import React from 'react';

export default function RegisterPage({ authForm = {}, handleAuthChange = () => {}, handleRegister = () => {}, switchToLogin = () => {}, error }) {
  return (
    <div className="auth-page">
      <h2>Create account</h2>
      <form className="auth-form" onSubmit={handleRegister}>
        <label htmlFor="register-name" className="sr-only">Full name</label>
        <input 
          id="register-name"
          name="name" 
          type="text"
          placeholder="Name" 
          value={authForm.name || ''} 
          onChange={handleAuthChange}
          autoComplete="name"
          required
          aria-required="true"
        />
        <label htmlFor="register-email" className="sr-only">Email address</label>
        <input 
          id="register-email"
          name="email" 
          type="email"
          placeholder="Email" 
          value={authForm.email || ''} 
          onChange={handleAuthChange}
          autoComplete="email"
          required
          aria-required="true"
        />
        <label htmlFor="register-password" className="sr-only">Password</label>
        <input 
          id="register-password"
          name="password" 
          type="password" 
          placeholder="Password" 
          value={authForm.password || ''} 
          onChange={handleAuthChange}
          autoComplete="new-password"
          required
          aria-required="true"
          minLength="6"
        />
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <button className="primary" type="submit">Register</button>
          <button type="button" className="small" onClick={switchToLogin}>Have an account?</button>
        </div>
        {error && <div className="error" role="alert">{error}</div>}
      </form>
    </div>
  );
}
